<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.consumerName"
              placeholder="请输入用户名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.phone"
              placeholder="请输入用户电话"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.storeName"
              placeholder="请输入零售户名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
        @exportZip="batchExportZip(masterList)"
      />
    </div>
    <!-- 查看-->
    <view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogViewTitle"
      :dialog-visible.sync="dialogViewVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 导出 batchExportZipMixin
import batchExportZipMixin from '@/mixin/batchExportZipMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 查看
import viewDialog from './components/viewDialog'
// 数据请求
import { loadAppConsumerStoreScanGetRaffleRecordListDataApi, loadAppConsumerStoreScanGetRaffleRecordExportDataApi, loadAppConsumerStoreScanGetRaffleRecordExportPicZipApi } from '@/api/appConsumerStoreScanGetRaffleRecord'

export default {
  name: 'AppConsumerStoreScanGetRaffleRecord',
  components: {
    CustomTable,
    TableOperation,
    viewDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin, batchExportZipMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'app_consumer_store_scan_get_raffle_record_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['app_consumer_store_scan_get_raffle_record_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['app_consumer_store_scan_get_raffle_record_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          },
          {
            permissionSigns: ['app_consumer_store_scan_get_raffle_record_export'],
            prop: 'exportZip',
            label: '导出图片',
            method: 'exportZip'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            consumerName: '',
            phone: '',
            storeName: ''
          }
        }
      },
      id: null, // 选中的单据ID
      eventType: '',
      dialogViewTitle: '',
      dialogViewVisible: false,
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'consumerId', filterColumn: 'c.id', label: '消费者编号', width: 120 },
      { prop: 'consumerName', filterColumn: 'c.name', label: '消费者名称', width: 120 },
      { prop: 'phoneStr', filterColumn: 'c.phone', filterValue: 'phone', label: '电话', width: 120 },
      { prop: 'address', filterColumn: 'c.address', label: '地址' },
      { prop: 'storeName', filterColumn: 's.store_name', label: '零售户名称', width: 160 },
      { prop: 'scanTimeStr', filterColumn: 'r.scan_time', label: '扫码时间', width: 160, isBetween: true },
      { prop: 'raffleTotal', filterColumn: 'r.raffle_total', label: '获得抽奖次数', width: 160 },
      { prop: 'raffledCount', filterColumn: 'r.raffled_count', label: '已抽奖次数', width: 160 }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadAppConsumerStoreScanGetRaffleRecordListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogViewVisible = !this.dialogViewVisible
      this.dialogViewTitle = '查看抽奖日志'
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadAppConsumerStoreScanGetRaffleRecordExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    },
    // 导出数据API
    ExportZipByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportZipObj) }
      loadAppConsumerStoreScanGetRaffleRecordExportPicZipApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
